import React from 'react';
import cx from 'classnames';
import { Container } from '@material-ui/core';
import css from './Footer.module.scss';
import useRebrandContext from 'helpers/hooks/useRebrandContext';

const Footer: React.FC = () => {
  const [newUi] = useRebrandContext();
  const footerClass = newUi ? 'rebrandFooter' : 'footer';

  return (
    <footer className={cx(footerClass, css[footerClass])}>
      <Container maxWidth="lg">
        LiveMore Capital Limited is authorised and regulated by the Financial Conduct Authority. Financial Services
        Register Firm Reference Number 820578. Registered in England and Wales no. 11630369, registered office: Unit 22
        2-4 Exmoor St, London, W10 6BD
      </Container>
    </footer>
  );
};

export default Footer;
